import {DraggableDirective} from './draggable.directive';
import {DropZoneDirective} from './drop-zone.directive';

export const DRAG_AND_DROP_COMPONENTS = [
    DraggableDirective,
    DropZoneDirective
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/drag-and-drop/index.ts